export function detectImageType(base64) {
	// Rimuove eventuali spazi o ritorni a capo
	const cleaned = base64.trim()

	// Decodifica i primi 4 byte
	const firstBytes = atob(cleaned.slice(0, 20))
		.split("")
		.map((c) => c.charCodeAt(0).toString(16).padStart(2, "0"))
		.join(" ")
		.toUpperCase()

	if (firstBytes.startsWith("89 50 4E 47")) {
		return "image/png"
	} else if (firstBytes.startsWith("FF D8 FF")) {
		return "image/jpeg"
	} else {
		return "unknown"
	}
}
